
import React from 'react';
import SkillTree from '../../skills/SkillTree';

const SkillsTab: React.FC = () => {
  return <SkillTree />;
};

export default SkillsTab;
